import styled from "styled-components";

const AccountDashboardWrapper = styled.div`
  background-color: var(--dashboard-box-background);
  border-radius: 5px;
  margin-bottom: 10px;
  height: 200px;
  width: 200px;
  & > div {
    height: 100%;
  }
`;

export { AccountDashboardWrapper };
